import { Component, OnDestroy } from "@angular/core";
import { DesignService } from "src/app/design/design.service";
import { Design, DesignsEntity } from "src/app/design/design.model";
import { Subscription } from "rxjs";
import { MatSnackBar } from "@angular/material";
import { AuthService } from "src/app/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LocationService } from "src/app/location/location.service";
import { Locations, LocationsEntity } from "src/app/location/location";

@Component({
  selector: "app-locations-select-designs",
  templateUrl: "./locations-select-designs.component.html",
  styleUrls: ["./locations-select-designs.component.css"],
})
export class LocationsSelectDesignsComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = false;
  designs: DesignsEntity[];
  
  location: LocationsEntity;
  

  searchDesign: string | number | any | null;

  constructor(
    private designService: DesignService,
    private locationService:LocationService,
    private snackBar: MatSnackBar,
    public auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
  ) {   this.route.queryParams.subscribe((queryParams: any) => {
    if (queryParams?.id) {
      this.getLocationById(queryParams.id);
    }
  }); }


  ngOnInit() {
    this.showLoader = true;
    this.auth.userProfileSubject$.subscribe(
      (profile) => {
        if (profile) {
          this.showLoader = false
          this.getDesignList();
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackBar.open(`Error in Getting Designer and Contractor Details`, "", {
          duration: 2000,
        });
      }
    );
  }


  /**
   * Get Design List
   */
  getDesignList() {
    this.showLoader = true;
    this.subscription$.add(
      this.designService.getDesignList().subscribe(
        (result: Design) => {
          this.designs = result.Designs;
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Design List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * Get Location Details By Id
   */
   getLocationById(locationId: String | number) {
    this.showLoader = true;
    this.subscription$.add(
      this.locationService
        .getSingleLocation(locationId)
        .subscribe((result: Locations) => {
          if (result?.Loc.length) {
            this.location = result?.Loc[0];
          }
          this.showLoader = false;
        },(error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Location Details. `, "", {
            duration: 2000,
          });
        })
    );
  }

  /**
   * Search For Specific designs
   */
  searchDesigns() {
    if (this.searchDesign !== "") {
      let searchValue = this.searchDesign.toLocaleLowerCase();
      this.designs = this.designs.filter((design) => {
        return (
          design.name.toLocaleLowerCase().match(searchValue) ||
          design.id.toString().match(searchValue)
        );
      });
    } else {
      this.getDesignList();
    }
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
